(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sectionRoot) {
    var root = sectionRoot || document.getElementById('ct-testimonials-{{ sid }}');
    if (!root) return;

    function equalizeHeights() {
      if (root.getAttribute('data-equal-height') !== 'true') return;
      var cards = root.querySelectorAll('[data-ct-card]');
      if (!cards.length) return;

      cards.forEach(function (c) { c.style.minHeight = ''; });
      var max = 0;
      cards.forEach(function (c) {
        var h = c.getBoundingClientRect().height;
        if (h > max) max = h;
      });
      cards.forEach(function (c) { c.style.minHeight = max + 'px'; });
    }

    // Equal height timing
    var imgs = root.querySelectorAll('img');
    imgs.forEach(function(img){
      if (img.complete) return;
      img.addEventListener('load', function(){ setTimeout(equalizeHeights, 60); });
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function(){ equalizeHeights(); });
      ro.observe(root);
    } else {
      window.addEventListener('resize', function(){ setTimeout(equalizeHeights, 150); });
    }

    // If not slider, stop here
    if (root.getAttribute('data-layout') !== 'slider') {
      equalizeHeights();
      return;
    }

    var track = root.querySelector('.ct-track');
    if (!track) return;

    // Robust button rebinding
    function rebindButton(btn, handler) {
      if (!btn || !btn.parentNode) return null;
      var clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);

      clone.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handler();
      });
      clone.addEventListener('pointerdown', function (e) {
        e.stopPropagation();
      });
      return clone;
    }

    // FIX: scroll by viewport width (never depends on card measurement)
    function scrollByViewport(dir) {
      var amount = track.clientWidth;
      if (!amount || amount < 50) amount = 320;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (root.getAttribute('data-arrows') === 'true') {
      var prevBtn = root.querySelector('.ct-prev');
      var nextBtn = root.querySelector('.ct-next');
      rebindButton(prevBtn, function(){ scrollByViewport(-1); });
      rebindButton(nextBtn, function(){ scrollByViewport(1); });
    }

    // Dots
    var dotsWrap = root.querySelector('.ct-dots');

    function getColsForViewport() {
      var cs = getComputedStyle(track);
      var d = parseInt(cs.getPropertyValue('--ct-cols-d') || '1', 10);
      var t = parseInt(cs.getPropertyValue('--ct-cols-t') || '1', 10);
      var m = parseInt(cs.getPropertyValue('--ct-cols-m') || '1', 10);

      if (window.matchMedia('(max-width: 767px)').matches) return m || 1;
      if (window.matchMedia('(max-width: 1024px)').matches) return t || 1;
      return d || 1;
    }

    function buildDots() {
      if (!dotsWrap || root.getAttribute('data-dots') !== 'true') return;
      dotsWrap.innerHTML = '';

      var cards = track.querySelectorAll('[data-ct-card]');
      if (!cards.length) return;

      var cols = getColsForViewport();
      var pages = Math.max(1, Math.ceil(cards.length / cols));

      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ct-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (pageIndex) {
          b.addEventListener('click', function () {
            var amount = track.clientWidth;
            if (!amount || amount < 50) amount = 320;
            track.scrollTo({ left: pageIndex * amount, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(b);
      }
    }

    function updateDotsActive() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.ct-dot');
      if (!dots.length) return;

      var amount = track.clientWidth;
      if (!amount || amount < 50) amount = 320;
      var p = Math.round(track.scrollLeft / amount);

      dots.forEach(function(d, idx){
        d.classList.toggle('is-active', idx === p);
      });
    }

    track.addEventListener('scroll', function(){ updateDotsActive(); });

    // Autoplay
    var autoplayOn = (root.getAttribute('data-autoplay') === 'true');
    var pauseOnHover = (root.getAttribute('data-pause-hover') === 'true');
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms') || '0', 10);
    var timer = null;

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function startAutoplay() {
      if (!autoplayOn || !autoplayMs) return;
      stopAutoplay();
      timer = setInterval(function(){ scrollByViewport(1); }, autoplayMs);
    }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);
    }

    buildDots();
    equalizeHeights();
    setTimeout(function(){ buildDots(); equalizeHeights(); updateDotsActive(); }, 200);
    window.addEventListener('resize', function(){
      setTimeout(function(){ buildDots(); equalizeHeights(); updateDotsActive(); }, 200);
    });

    startAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(); });
  } else {
    init();
  }

  // Theme editor support (re-init when section reloads)
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var el = event.target.querySelector('#ct-testimonials-{{ sid }}');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
